import TopNav from "@/components/TopNav";
import IdleLogout from "@/components/IdleLogout";

export default function AppShell({ children }) {
  return (
    <div className="min-h-screen bg-pf-bg text-pf-text">
      <TopNav />
      <main className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        {children}
      </main>
      <IdleLogout />
    </div>
  );
}
